import { useMemo } from 'react';

import * as config from '.';

import { Providers } from './providers';

import { useSenderProvider } from '../entities/providers/hooks';

export function useStripeConfig() {
  const provider = useSenderProvider();

  return useMemo(() => {
    const conf = provider === Providers.InPostGB ? config.inPostGBStripeConfig : config.stripeConfig;

    return config.isLive ? conf.production : conf.sandbox;
  }, [provider]);
}

export function useStripeCountry() {
  const provider = useSenderProvider();

  return useMemo(() => (provider === Providers.InPostGB ? 'GB' : 'GR'), [provider]);
}

export function useCanStripeCard() {
  // allow for all countries now
  return true;
}
